import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Stage, StageRole } from "../types/model/stage";
import { NavigationStore } from "../types/store/NavigationStore";
import { styleText } from "node:util";

const initialState: NavigationStore = JSON.parse(
  sessionStorage.getItem("navigation") || "{}"
);

const navigation = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setNavigation: (
      state,
      action: PayloadAction<{
        accountId: number | undefined;
        projectId: number | undefined;
        activityId: number | undefined;
        procedureId: number | undefined;
        stageId: number | undefined;
      }>
    ) => {
      state.accountId = action.payload.accountId;
      state.projectId = action.payload.projectId;
      state.activityId = action.payload.activityId;
      state.procedureId = action.payload.procedureId;
      state.stageId = action.payload.stageId;
    },
    setStageRole: (state, action: PayloadAction<StageRole>) => {
      state.stageRole = action.payload;
    },
    setCurrentStage: (state, action: PayloadAction<Stage>) => {
      state.currentStage = action.payload;
    },
    clearStageRole: (state) => {
      state.stageRole = undefined;
    },
    clearCurrentStage: (state) => {
      state.currentStage = undefined;
    },
    clearNavigation: (state) => {
      state.accountId = undefined;
      state.projectId = undefined;
      state.activityId = undefined;
      state.procedureId = undefined;
      state.stageId = undefined;
      state.stageRole = undefined;
      state.currentStage = undefined;
      sessionStorage.setItem("navigation", JSON.stringify({}));
    },
  },
});

export const {
  setNavigation,
  setStageRole,
  setCurrentStage,
  clearStageRole,
  clearCurrentStage,
  clearNavigation,
} = navigation.actions;

export default navigation.reducer;
